module.exports = __webpack_public_path__ + "static/media/qr_code_slider_phone2.0bf96fd3.png";